import React from 'react'
import { NavLink } from 'react-router-dom'

const SubNav = ({items, onNav}) => (
  <nav className="subnav">
    {items && items.map((item, i) => {
      if (!item.hidden) {
        return(
          <NavLink activeClassName="active" to={item.link} key={`navlink_${i}`} onClick={() => (onNav())}>{item.title}</NavLink>
        )
      }
      return null;
    })}
  </nav>
);

export default SubNav



// WEBPACK FOOTER //
// ./src/components/SubNav.js